<template slot="main">
  <el-dialog :visible.sync="open" :before-close="handleClose">
    <div>
      <div class="flex justify-around items-center mb-1">
        <h2 class="text-xl text-center">Gift winner</h2>
        <common-button type="primary" @click="exportCSV" icon="el-icon-download">Export CSV</common-button>
      </div>
      <div class="bg-white rounded shadow p-8">
        <div class="mb-2 mt-2 inline-block min-w-full shadow rounded-lg overflow-hidden">
          <table class="min-w-full leading-normal">
            <thead>
              <tr>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  UUID
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  NICKNAME
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  PRICE
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  DATE
                </th>
              </tr>
            </thead>
            <tbody v-if="stats.wheelStats">
              <tr v-for="stat in stats.wheelStats" :key="wheel.id">
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="text-gray-900 whitespace-no-wrap">{{ stat.uuid }}</p>
                </td>

                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="text-gray-900 whitespace-no-wrap">{{ stat.nickname }}</p>
                </td>

                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="text-gray-900 whitespace-no-wrap">{{ stat.price }}</p>
                </td>

                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="text-gray-900 whitespace-no-wrap">{{ stat.date | date }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment'

export default {
  name: 'WheelStats',

  props: {
    open: {
      type: Boolean,
      required: true
    },
    wheel: {
      type: Object,
      required: true
    },
    stats: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      chart: null
    }
  },
  mounted() {
    for (let stat of this.stats.wheelStats) {
      stat.date = moment.unix(stat.date.sec).format('YYYY-MM-DD HH:mm:ss');
    }
  },
  methods: {
    exportCSV() {
      this._downloadCSV(this.stats.wheelStats, this.wheel.code)
    },

    handleClose() {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/wheels/ui/modal/stats.vue